import React, { useState } from 'react';
import './css/Icse.css'; // Dedicated page styles
import { useNavigate } from "react-router-dom";


// Reusing your standalone, modular layout components
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

// Import your custom images here
import icseHeroBg from '../images/banner-icse.jpg';
import icseDetailsImg from '../images/icse.png';

// Import your custom images here at the top
import icsetrajectoryImg from '../images/ICSE_Internal_Exam_illustration.png'; // New Background Import
import featureSectionBg2 from '../images/Banner3.png'; // New Background Import

// Slide-Specific Image Imports
import icsesupportImg from '../images/CBSE_Support.png';
import featureLeftImg2 from '../images/forum-dash1.png';
import featureLeftImg3 from '../images/forum-dash1.png';

import dynamicBg from "../images/Banner6.png"; // New background image asset
import thumb1 from "../images/core1.png";
import thumb2 from "../images/core2.png";
import thumb3 from "../images/core3.png";
import thumb4 from "../images/core4.png";

// Importing images or using dynamic asset paths matching your project structure
import feat1 from "../images/Icon-01.png";
import feat2 from "../images/Icon-02.png";
import feat3 from "../images/Icon-03.png";
import feat4 from "../images/Icon-04.png";
import feat5 from "../images/Icon-04.png";
import feat6 from "../images/Icon-06.png";
import feat7 from "../images/Icon-07.png";
import feat8 from "../images/Icon-08.png";

import Team1 from '../images/founders-icon.png';
import Team2 from '../images/advisors-icon.png';
import Team3 from '../images/patrons-icon.png';
import Team4 from '../images/board-members-icon.png';


import courses1 from '../images/icse-01.jpg';
import courses2 from '../images/icse-02.jpg';
import courses3 from '../images/icse-03.jpg';
import courses4 from '../images/icse-04.jpg';
import courses5 from '../images/icse-05.jpg';
import courses6 from '../images/icse-06.jpg';
import courses7 from '../images/icse-07.jpg';
import courses8 from '../images/icse-08.jpg';
import courses9 from '../images/icse-09.jpg';
import courses10 from '../images/icse-10.jpg';
import courses11 from '../images/icse-11.jpg';
import courses12 from '../images/icse-12.jpg';
import courses13 from '../images/icse-13.jpg';
import courses14 from '../images/icse-14.jpg';
import courses15 from '../images/icse-15.jpg';
import courses16 from '../images/icse-16.jpg';
import courses17 from '../images/icse-17.jpg';
import courses18 from '../images/icse-18.jpg';
import courses19 from '../images/icse-19.jpg';
import courses20 from '../images/icse-20.jpg';
import courses21 from '../images/icse-21.jpg';
import courses22 from '../images/icse-22.jpg';

// React Icons (Using react-icons/fa or similar icon framework)
import { FaCheckCircle } from "react-icons/fa";

import DownloadApp from './components/DownloadApp';

function Icse() {
  const navigate = useNavigate();

  // Array holding all box content items
  const allBoxes = [
    {
      id: 1,
      img: courses1,
      title: "Mathematics - FSD + CMC",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 2,
      img: courses2,
      title: "Physics - FSD + CMC",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 3,
      img: courses3,
      title: "Chemistry - FSD + CMC",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 4,
      img: courses4,
      title: "Biology - FSD + CMC",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 5,
      img: courses5,
      title: "Geography - FSD + CMC",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 6,
      img: courses6,
      title: "History & Civics - FSD + CMC",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 7,
      img: courses7,
      title: "Economics - FSD + CMC",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 8,
      img: courses8,
      title: "Mathematics - CMC",
      subtitle: "Duration: Till the end of academic year. | e-Library: Yes"
    },
    {
      id: 9,
      img: courses9,
      title: "Physics - CMC",
      subtitle: "Duration: Till the end of academic year. | e-Library: Yes"
    },
    {
      id: 10,
      img: courses10,
      title: "Chemistry - CMC",
      subtitle: "Duration: Till the end of academic year. | e-Library: Yes"
    },
    {
      id: 11,
      img: courses11,
      title: "Biology - CMC",
      subtitle: "Duration: Till the end of academic year. | e-Library: Yes"
    },
    {
      id: 12,
      img: courses12,
      title: "Geography - CMC",
      subtitle: "Duration: Till the end of academic year. | e-Library: Yes"
    },
    {
      id: 13,
      img: courses13,
      title: "History & Civics - CMC",
      subtitle: "Duration: Till the end of academic year. | e-Library: Yes"
    },
    {
      id: 14,
      img: courses15,
      title: "Economics - CMC",
      subtitle: "Duration: Till the end of academic year. | e-Library: Yes"
    },
    {
      id: 15,
      img: courses14,
      title: "All Rounder",
      subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes"
    },
    {
      id: 16,
      img: courses16,
      title: "Mathematics - FSD",
      subtitle: "Duration: Till the end of academic year. | Test: Yes"
    },
    {
      id: 17,
      img: courses17,
      title: "Physics - FSD",
      subtitle: "Duration: Till the end of academic year. | Test: Yes"
    },
    {
      id: 18,
      img: courses18,
      title: "Chemistry - FSD",
      subtitle: "Duration: Till the end of academic year. | Test: Yes"
    },
    {
      id: 19,
      img: courses19,
      title: "Biology - FSD",
      subtitle: "Duration: Till the end of academic year. | Test: Yes"
    },
    {
      id: 20,
      img: courses20,
      title: "Geography - FSD",
      subtitle: "Duration: Till the end of academic year. | Test: Yes"
    },
    {
      id: 21,
      img: courses21,
      title: "History & Civics - FSD",
      subtitle: "Duration: Till the end of academic year. | Test: Yes"
    },
    {
      id: 22,
      img: courses22,
      title: "Economics - FSD",
      subtitle: "Duration: Till the end of academic year. | Test: Yes"
    }
  ];

  // State tracker toggles whether all elements show or just the initial 4
  const [showAll, setShowAll] = useState(false);

  // Filters items dynamically based on the toggle state
  const visibleBoxes = showAll ? allBoxes : allBoxes.slice(0, 4);

  const mergedFeatures = [
    {
      id: 1,
      title: "Structured Academic Exploration",
      accent: "accent-blue",
      image: feat1,
      alt: "Structured Academic Exploration",
      description: "Very structured and in-depth academic exploration. For its vast syllabus, candidates need to pay equal focus on each and every subject. The syllabus also being factual, emphasis must be given to learn the facts too to score well.",
    },
    {
      id: 2,
      title: "Wide Range of Subjects",
      accent: "accent-yellow",
      image: feat2,
      alt: "Wide Range of Subjects",
      description: "Wide range of subjects offered. By offering a variety of creative subjects as per choice and preference, ICSE Board gives emphasis on grasping the practical knowledge. It also puts equal stress on every subject and stream.",
    },
    {
      id: 3,
      title: "Global Acknowledgement & Prestige",
      accent: "accent-yellow",
      image: feat3,
      alt: "Global Acknowledgement",
      description: "The certificate carries enormous acknowledgement and prestige worldwide. The primary benefit of the certificate provided by ICSE is that candidates can quite easily get themselves enrolled in a foreign institution.",
    },
    {
      id: 4,
      title: "NEP-Aligned Examinations",
      accent: "accent-blue",
      image: feat4,
      alt: "NEP-Aligned Examinations",
      description: "The ICSE examination is conducted in accordance with the recommendations of the NEP, 1986 . It successfully conducts the Examination every year giving much relief for both the candidates and the guardians.",
    },
    {
      id: 5,
      title: "Exclusive English Medium",
      accent: "accent-blue",
      image: feat5,
      alt: "Exclusive English Medium",
      description: "Only English medium. The medium of ICSE Examination is English, except the Indian language paper. The Board does not encourage any other language but English. ICSE is therefore restricted to only English medium schools.",
    },
    {
      id: 6,
      title: "Core Subjects & SUPW",
      accent: "accent-yellow",
      image: feat6,
      alt: "Core Subjects and SUPW",
      description: "Candidates need to sit for six subjects and Socially Useful Productive Work (SUPW). ICSE results are calculated on the basis of the best five subjects of the candidates and one needs to know that English language is compulsory.",
    },
    {
      id: 7,
      title: "School-Enrolled Regular Candidature",
      accent: "accent-yellow",
      image: feat7,
      alt: "Regular Candidature",
      description: "The examination presupposes ten years of schooling. Private candidates are not permitted to take the examination. The Board does not accept private candidates. They must come only via ICSE affiliated English medium schools.",
    },
    {
      id: 8,
      title: "Superior English Fluency",
      accent: "accent-blue",
      image: feat8,
      alt: "English Fluency",
      description: "English fluency. ICSE strictly gives stress on English fluency. This results in students having good command over the language and easily qualify in the examinations like TOEFL and IELTS.",
    },
  ];

  return (
    <div className="icse-page-wrapper">

      {/* 1. Header Hero Section with integrated clean Navbar */}
      <section
        className="icse-hero-section"
        style={{ backgroundImage: `url(${icseHeroBg})` }}
      >
        <Navbar />
      </section>

      {/* 2. Core Narrative & Brand Pillars Section */}
      <section className="icse-details-section">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* Left Column: Contextual Narrative */}
            <div className="col-lg-6">
              <p className="info-small-text">KNOW YOUR COUNCIL</p>

              <h2 className="icse-section-heading">
                Empowering Every Student to Learn & Succeed
              </h2>

              <div className="zigzag-divider mb-4"></div>

              <p className="icse-body-text">
                Post-Independence, there was another national mandate literally demanding
                the country's own examination system by replacing the overseas Cambridge
                School Certificate Examination.
              </p>

              <p className="icse-body-text">
                Presently the Council for the Indian School Certificate Examinations
                (CICSE) is dedicated to steadfastly serving the nation's children with
                the best quality of education, to empower them to contribute towards a
                compassionate and peaceful society.
              </p>

              <p className="icse-body-text highlighted-paragraph">
                Crestest builds on this foundation by supporting students with focused
                board exam preparation, competitive test series, the free
                "Try Before You Buy" portal, Scholars' Forum, and the nationwide
                Kirnavali challenge.
              </p>

              {/* Metric Pillars Grid */}
              <div className="row g-3 mt-4">
                <div className="col-sm-4">
                  <div className="metric-box box-blue">
                    <h3 style={{ color: "#fff" }}>AI</h3>
                    <p style={{ color: "#fff", fontSize: "11px" }}>
                      Personalized Learning
                    </p>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="metric-box box-yellow">
                    <h3 style={{ color: "#fff" }}>24/7</h3>
                    <p style={{ color: "#fff" }}>
                      Smart Practice
                    </p>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="metric-box box-teal">
                    <h3 style={{ color: "#fff" }}>FREE</h3>
                    <p style={{ color: "#fff", fontSize: "11px" }}>
                      Try Before You Buy
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Clean, Unboxed Raw Image Layout */}
            <div className="col-lg-6 text-center">
              <img
                src={icseDetailsImg}
                alt="Enterprise Architecture"
                className="img-fluid"
                style={{
                  border: "none",
                  boxShadow: "none",
                  outline: "none",
                  borderRadius: 0,
                  background: "transparent",
                  display: "block",
                  margin: "0 auto"
                }}
              />
            </div>

          </div>
        </div>
      </section>


      {/* 4. NEW: Expandable Grid Grid Section */}
      <section
        className="dynamic-grid-section"
        style={{ backgroundImage: `url(${dynamicBg})` }}
      >
        <div className="container">

          {/* Section Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8 d-flex flex-column align-items-center">
              <p className="cards-small-text">CBSE Courses</p>

              <h2 className="cards-main-heading">
                The CBSE Courses We Offer
              </h2>

              <div className="zigzag-border"></div>
            </div>
          </div>

          {/* Responsive 4-Column Grid Array */}
          <div className="row g-4 justify-content-center transition-grid">
            {visibleBoxes.map((box) => (
              <div className="col-sm-6 col-md-4 col-lg-3" key={box.id}>
                <div className="grid-item-card">
                  <div className="grid-thumb-wrap">
                    <img src={box.img} alt={box.title} className="grid-card-img" />
                  </div>
                  <div className="grid-card-body text-center">
                    <h4 className="grid-title">{box.title}</h4>
                    <p className="grid-subtitle">{box.subtitle}</p>
                    {/* <a href={box.link} className="btn grid-action-btn">
                                            VIEW DETAILS
                                        </a> */}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Expandable Pagination Control Button */}
          {allBoxes.length > 4 && (
            <div className="row mt-5">
              <div className="col-12 text-center">
                <button
                  className="btn view-more-toggle-btn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "SHOW LESS" : "VIEW MORE"}
                </button>
              </div>
            </div>
          )}

        </div>
      </section>




      {/* 4. Glassmorphic Grid Services / Capabilities Section */}
      <section className="icse-grid-bg-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
        <div className="container">

          {/* Centralized Section Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <span className="grid-section-mini-tag">Key features</span>
              <h2 className="grid-section-heading">ICSE works with the vision of being “committed to equity and excellence in education.”</h2>
              <div className="zigzag-border mx-auto mt-3"></div>
            </div>
          </div>

          {/* Dynamic 2 Cards Per Row Grid */}
          <div className="row g-4 justify-content-center">
            {mergedFeatures.map((feature) => (
              <div className="col-lg-6" key={feature.id}>
                <div className="glass-grid-box h-100">
                  <div className="grid-box-inner">
                    <div className={`grid-square-icon-wrapper ${feature.accent}`}>
                      <img
                        src={feature.image}
                        alt={feature.alt}
                        className="grid-panel-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>

                    <div className="grid-box-text-block">
                      <h4>{feature.title}</h4>
                      <p className="mb-0">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>


      <section className="icse-details-section py-5" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
        <div className="container">
          {/* Professional Border-Radiused & Box-Shadowed Container Box */}
          <div
            className="p-4 p-lg-5 bg-white rounded-4"
            style={{
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
              border: "1px solid rgba(0, 0, 0, 0.04)"
            }}
          >
            <div className="row align-items-center g-5">

              {/* Left Column: Contextual Narrative & Academic Trajectory Setting */}
              <div className="col-lg-6">
                <span className="info-small-text text-uppercase fw-bold text-primary tracking-wide">
                  ACADEMIC TRAJECTORY SETTING
                </span>

                <h2
                  className="icse-section-heading fw-bold mt-2 mb-3"
                  style={{ fontSize: "2rem", color: "#2d3748" }}
                >
                  Academic Trajectory Setting
                </h2>

                <div
                  className="zigzag-divider mb-4"
                  style={{
                    width: "50px",
                    height: "4px",
                    background: "#3182ce",
                    borderRadius: "2px",
                  }}
                ></div>

                <p
                  className="icse-body-text text-muted mb-4"
                  style={{ lineHeight: "1.7" }}
                >
                  An ongoing, comprehensive process of evaluating and setting of
                  individual academic trajectories based on those evaluations. These
                  are conducted internally, unknown to the students, throughout the
                  academic session.
                </p>

                {/* Structured Pointers List with React Icons */}
                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>Subject Selection:</strong> Subject depends on the
                      student's Class IX final examination.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>Promotion:</strong> The Head of the Institute ensures
                      promotion.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>Attendance Criteria:</strong> A minimum attendance of
                      75% is required.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>Promotion Policy:</strong> Promotion on a trial basis
                      is not accepted.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>Re-examination:</strong> Re-examinations are not
                      allowed.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>Grace Marks:</strong> Awarding of grace marks is not
                      permissible.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>SUPWCS Evaluation:</strong> SUPWCS is assessed by the
                      school.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Right Column: Clean, Unboxed Raw Image Layout */}
              <div className="col-lg-6 text-center">
                <img
                  src={icsetrajectoryImg}
                  alt="Academic Trajectory Architecture"
                  className="img-fluid"
                  style={{
                    border: "none",
                    boxShadow: "none",
                    outline: "none",
                    borderRadius: 0,
                    background: "transparent",
                    display: "block",
                    margin: "0 auto",
                    maxHeight: "450px",
                    objectFit: "contain"
                  }}
                />
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Download App Section */}
      <DownloadApp />


      {/* Support & Pedagogy Section */}
      <section className="icse-details-section py-5" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
        <div className="container">
          <div
            className="p-4 p-lg-5 bg-white rounded-4"
            style={{
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
              border: "1px solid rgba(0, 0, 0, 0.04)"
            }}
          >
            <div className="row align-items-center g-5">

              {/* Right Column: Illustration Image */}
              <div className="col-lg-6 text-center">
                <img
                  src={icsesupportImg}
                  alt="Support and Pedagogy Illustration"
                  className="img-fluid"
                  style={{
                    border: "none",
                    boxShadow: "none",
                    outline: "none",
                    borderRadius: 0,
                    background: "transparent",
                    display: "block",
                    margin: "0 auto",
                    maxHeight: "450px",
                    objectFit: "contain"
                  }}
                />
              </div>

              {/* Left Column: Support & Pedagogy Narrative & Pointers */}
              <div className="col-lg-6">
                <span className="info-small-text text-uppercase fw-bold text-primary tracking-wide">
                  EXPERT ASSISTANCE
                </span>

                <h2
                  className="icse-section-heading fw-bold mt-2 mb-3"
                  style={{ fontSize: "2rem", color: "#2d3748" }}
                >
                  Support & Comprehensive Pedagogy
                </h2>

                <div
                  className="zigzag-divider mb-4"
                  style={{
                    width: "50px",
                    height: "4px",
                    background: "#3182ce",
                    borderRadius: "2px",
                  }}
                ></div>

                <p
                  className="icse-body-text text-muted mb-4"
                  style={{ lineHeight: "1.7" }}
                >
                  Crestest offers premium services and in-depth support for students
                  enrolled in ICSE. Our pedagogy of practice includes FSD, CMC, NBF
                  and PSC. FSD will help students understand their current academic
                  level through online tests and subsequent assessment. CMC, with its
                  vast collection of digital content, will resource them with the
                  necessary knowledge and skills. The unique NBF facility, with the
                  notes, whiteboard and faculty in a single window, will facilitate
                  powerful learning opportunities during online classes. The PSC will
                  help them track their growth and plan the next step. In addition,
                  counselling support can bring self-awareness and the ability to move
                  forward with a growth mindset.
                </p>

                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>FSD:</strong> Helps students understand their current
                      academic level through online tests and subsequent assessment.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>CMC:</strong> With its vast collection of digital content,
                      provides students with the necessary knowledge and skills.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>NBF:</strong> The unique facility brings notes, a
                      whiteboard and faculty together in a single window, facilitating
                      powerful learning opportunities during online classes.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>PSC:</strong> Helps students track their growth and plan
                      their next step.
                    </span>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle
                      className="text-primary mt-1 me-3 flex-shrink-0"
                      size={18}
                    />
                    <span>
                      <strong>Counselling Support:</strong> Builds self-awareness and
                      helps students move forward with a growth mindset.
                    </span>
                  </li>
                </ul>
              </div>



            </div>
          </div>
        </div>
      </section>

      {/* 3. Reusable Global Bottom Components */}
      <Newsletter />
      <Footer />

    </div>
  );
}

export default Icse;